<template>
	<div class="mb-3 flex items-center justify-between pb-2 pt-3">
		<!-- Back button and title container -->
		<div class="flex items-center">
			<!-- Back button -->
			<div
				v-if="back"
				class="mr-3"
			>
				<button
					class="button icon-button"
					@click="router.back()"
				>
					<i class="material-icons text-[3.2rem]">arrow_back</i>
				</button>
			</div>
			<!-- Title -->
			<h1 class="text-[3.2rem] font-semibold text-dark-green">{{ capitalizeFirstLetter(title || '') }}</h1>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { defineProps } from "vue";
	import { useRouter } from "vue-router";
	import { capitalizeFirstLetter } from "@/composables/utils";
	const props = defineProps({
		title: String,
		back: Boolean,
	});

	const router = useRouter();

</script>
